import React from 'react'
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  Router,
} from 'react-router-dom'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { Provider } from 'react-redux'
import { persistor, store } from '../../store/index'
import { routes } from '../../constantes/routes'

import LoginRoute from '../protectedRoutes/LoginRoute'
import Landing from '../landing/Landing'
import LoginContainer from '../login/LoginContainer'
import ForgotContainer from '../login/forgot-password/ForgotContainer'
import ResetContainer from '../login/reset-password/ResetContainer'

import AccessPresentationRoute from '../accessToPresentationByContact/protectedRoute/AccessPresentationRoute'
import ProtectedRoutePresentation from '../accessToPresentationByContact/protectedRoute/ProtectedRoutePresentation'
import LandingToPresentation from '../accessToPresentationByContact/landing/LandingToPresentation'
import ViewContactHospitalPresentationContainer from '../accessToPresentationByContact/ViewContactHospitalPresentationContainer'
import AppContainer from './AppContainer'
import ProtectedRoute from '../protectedRoutes/ProtectedRoute'
import LgpdPolicy from '../lgpd/LgpdPolicy'

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <BrowserRouter>
          <Switch>
            {/* Ruta raíz - redirige a MAIN si está autenticado */}
            <Route exact path='/'>
              <ProtectedRoute>
                <Redirect to={routes.MAIN} />
              </ProtectedRoute>
            </Route>

            {/* Rutas publicas */}
            {/* <Route exact path={routes.LANDING} component={Landing} /> */}
            <LoginRoute exact path={routes.LOGIN} component={LoginContainer} />
            <Route path={routes.LGPD_POLICY} component={LgpdPolicy} />
            <Route path={routes.RESET} component={ResetContainer} />

            <Route path={routes.FORGOT} component={ForgotContainer} />
            {/* AccessToPresentationByContact */}
            <AccessPresentationRoute
              path={routes.LANDING_ACCESS_TO_PRESENTATION_BY_CONTACT + ':id'}
              component={LandingToPresentation}
            />
            <ProtectedRoutePresentation
              path={routes.VIEW_CONTACT_PRESENTATION + ':id'}
              component={ViewContactHospitalPresentationContainer}
            />
            {/* Rutas privadas */}
            <ProtectedRoute component={AppContainer} />
          </Switch>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  )
}

export default App
